module.exports = __webpack_public_path__ + "img/wildwood-sign.9f7e5be7.png";